import React from 'react';
import addModifiers from 'utils/add_modifiers';
import Skipped from './Skipped';
import IlosScreenRecording from '../Ilos/IlosScreenRecording';
import IlosWebcamRecording from '../Ilos/IlosWebcamRecording';

// eslint-disable-next-line
const ActionPrompt = props => {
  const { skipped, isWebcamRecording, isScreenRecording } = props;
  const buttonStyles = `${addModifiers('CustomColor', [
    'backgroundColor',
    'buttonBoxShadow',
  ])} ${addModifiers('NewButton', ['tallAndWide', 'lessonlyBrandColor'])}`;

  if (skipped) {
    return <Skipped {...props} />;
  }
  if (isScreenRecording) {
    return <IlosScreenRecording {...props} buttonStyles={buttonStyles} />;
  }
  if (isWebcamRecording) {
    return <IlosWebcamRecording {...props} buttonStyles={buttonStyles} />;
  }
};

export default ActionPrompt;
